// CookieBannerStyles.js
import styled from 'styled-components';
export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* Halbtransparentes Schwarz */
  display: flex;
  justify-content: center;
  align-items: end;
  z-index: 1000;
`;

export const BannerContainer = styled.div`
  background-color: #2b373b;
  color: #ffffff;
  padding: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 8px;
  text-align: center;
`;

export const BannerMessage = styled.p`
  margin: 0;
  font-size: 14px;
  flex-grow: 1;
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
`;

export const AcceptButton = styled.button`
  background-color:rgb(19, 19, 19);
  color: #ffffff;
  border: none;
  padding: 10px 20px;
  cursor: pointer;
  border-radius: 5px;
`;

export const DeclineButton = styled.button`
  background-color:rgb(19, 19, 19);
  color: #ffffff;
  border: none;
  padding: 10px 20px;
  cursor: pointer;
  border-radius: 5px;
`;